module.exports = __webpack_public_path__ + "static/media/js3.c1380af6.jpeg";